/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description updateUrlParam -- ref: http://stackoverflow.com/a/15023688/1721547
 */

export const updateUrlParam = (
  uri: string,
  key: string,
  value?: boolean | string | number | null | undefined
) => {
  const re = new RegExp(`([?&])${key}(?:=.*?)?(&|#|$)`, 'i')
  const trues: Array<typeof value> = [true, 'true']
  if (value === undefined || value === null) {
    if (uri.match(re)) {
      return uri.replace(re, '$1$2').replace('?&', '?').replace(/[?&]$/, '')
    }
    return uri
  } else if (uri.match(re)) {
    return uri.replace(
      re,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      trues.includes(value) ? `$1${key}$2` : `$1${key}=${value}$2`
    )
  }

  let hash = ''
  let cleanUri = uri
  if (uri.includes('#')) {
    hash = uri.replace(/.*#/, '#')
    cleanUri = uri.replace(/#.*/, '')
  }
  const separator = cleanUri.includes('?') ? '&' : '?'
  return `${cleanUri}${separator}${
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    trues.includes(value) ? key : `${key}=${value}`
  }${hash}`
}
